import { gql } from '@apollo/client';

export const GET_MUSICS = gql`
  query SkWeb_GetMusics($sectionId: ID!) {
    musics(sectionId: $sectionId) {
      id
      name
      size
      domain
      key
      createdAt
      status
    }
  }
`;
